import React from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CListGroup,
  CListGroupItem,
  CTooltip,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilBolt,
  cilCalendarCheck,
  cilChartLine,
  cilChevronRight,
  cilExternalLink,
  cilPencil,
  cilPeople,
  cilSpeedometer,
  cilUserPlus,
} from '@coreui/icons'
import { useNavigate } from 'react-router-dom'

const QuickActionsCard = ({ steps, onActivateGame }) => {
  const navigate = useNavigate()

  const activateStep = steps.find((step) => step.key === 'activate_game')
  const priorStepsCompleted = steps
    .filter((step) => step.key !== 'activate_game')
    .every((step) => step.status === 'completed')
  const canActivate = priorStepsCompleted && activateStep?.status !== 'completed'

  const previewMemberView = () => {
    const admin = JSON.parse(localStorage.getItem('admin'))
    window.open(
      `${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${admin?.username}`,
      '_blank',
    )
  }

  const actions = [
    { label: 'Dashboard', icon: cilSpeedometer, onClick: () => navigate('/dashboard') },
    { label: 'Add Players', icon: cilUserPlus, onClick: () => navigate('/players') },
    { label: 'Add Teams', icon: cilPeople, onClick: () => navigate('/teams') },
    {
      label: 'Create Fixtures',
      icon: cilCalendarCheck,
      onClick: () => navigate('/create-fixtures'),
    },
    // { label: 'Preview Member View', icon: cilExternalLink, onClick: previewMemberView },
    { label: 'Manage Scores', icon: cilPencil, onClick: () => navigate('/manage-scores') },
    {
      label: 'Fantasy Leaderboard',
      icon: cilChartLine,
      onClick: () => navigate('/fantasy-leaderboard'),
    },
  ]

  return (
    <CCard className="mb-4">
      <CCardHeader>Quick Actions</CCardHeader>
      <CCardBody className="p-0">
        <CListGroup flush>
          {actions.map((action) => (
            <CListGroupItem
              key={action.label}
              className="d-flex align-items-center justify-content-between"
              style={{ cursor: 'pointer' }}
              onClick={action.onClick}
            >
              <span>
                <CIcon icon={action.icon} className="me-2" />
                {action.label}
              </span>
              <CIcon icon={cilChevronRight} />
            </CListGroupItem>
          ))}
          <CTooltip
            content={
              canActivate
                ? 'Activate your game to make it live for members.'
                : 'View activation checklist and complete any remaining prerequisites.'
            }
          >
            <CListGroupItem
              className={`d-flex align-items-center justify-content-between fw-bold ${
                canActivate ? 'text-success' : 'text-medium-emphasis'
              }`}
              style={{ cursor: 'pointer' }}
              onClick={onActivateGame}
            >
              <span>
                <CIcon icon={cilBolt} className="me-2" />
                Activate Game
              </span>
              <CIcon icon={cilChevronRight} />
            </CListGroupItem>
          </CTooltip>
        </CListGroup>
      </CCardBody>
    </CCard>
  )
}

export default QuickActionsCard
